module.exports = __webpack_public_path__ + "public/images/reading-background-pattern.ac617a717fb6993f19953dfaaa48d41e.svg";